module.exports = __webpack_public_path__ + "static/media/check.0dc1fc13.svg";